const SUPPROTED_FILE_FORMATS = [
  '.pdf',
  '.jpeg',
  '.jpg',
  '.png',
  '.xls',
  '.xlsx',
  '.doc',
  '.docx',
  '.ppt',
  '.pptx'
]

export const checkFileFormat = (file: File) => {
  return SUPPROTED_FILE_FORMATS.some((supportedFormat) =>
    file.name.toLowerCase().endsWith(supportedFormat)
  )
}
